// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

const sagaScopeSchema = z.object({
  originSystemUrl: z.string(),
  originSystemId: z.string(),
  originOrgId: z.string(),
  syncPolicy: z.enum(['agent-portable', 'public', 'org-internal', 'org-confidential']),
  lastSyncedAt: z.string().max(200).datetime().nullable(),
})

export const sagaMemorySchema = z.object({
  id: z.string().max(200),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),

  agentId: z.string().max(200),
  memoryType: z.enum(['episodic', 'semantic', 'procedural']),

  eventType: z.string().max(100).optional(),
  summary: z.string().max(10000),
  learnings: z.string().max(10000).optional(),
  significance: z.number().min(0).max(1).optional(),

  knowledgeDomain: z.string().max(200).optional(),
  expertiseLevel: z.enum(['expert', 'proficient', 'familiar']).optional(),

  workflowName: z.string().max(200).optional(),
  workflowSteps: z.array(z.string()).optional(),

  scope: sagaScopeSchema,

  linkedTaskId: z.string().max(200).optional(),
  linkedSystemTaskId: z.string().max(200).optional(),

  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
})

export type SagaMemoryInput = z.infer<typeof sagaMemorySchema>
export { sagaScopeSchema }
